export enum GuestAccessLevel {
    CanEdit = 'can_edit',
    CanView = 'can_view'
}

export interface GuestInfo {
    guestId: string;
    guestRecordId?: string;
    email: string;
    name?: string;
    profileImageUrl?: string;
    accessLevel: GuestAccessLevel;
    status: 'active' | 'invited' | 'revoked' | 'declined';
    grantedDate?: string;
    canSwap?: boolean;
    lastGuestSwapDate?: string;
    lastSwapDate?: string;
}

export interface ProjectGuestInfo extends GuestInfo {
    projectId: string;
    projectName?: string;
    ownerName?: string;
    ownerProfileImageUrl?: string;
    invitedByName?: string;
}

export interface SharedProjectInfo {
    guestRecordId: string;
    projectId: string;
    project?: {
        name: string;
        createdDate?: string;
    };
    owner?: {
        username: string;
        profileImageUrl?: string;
    };
    accessLevel: GuestAccessLevel;
}
